import { Path } from 'history';
import { useCallback } from 'react';
import { generatePath } from 'react-router-dom';
import { getRouteById } from 'lib/routes';
import { encodeQuery } from 'lib/transport';
import { RouteIdentifier, RouteParams } from 'types/routing';
import { QueryParams } from 'types/transport';

export const useLocationDescriptor = (routeId: RouteIdentifier) =>
  useCallback(
    (params?: RouteParams, query?: QueryParams) => {
      // Retrieve route configuration
      const route = getRouteById(routeId);

      // Ensure route has a valid path specified (ignore 404 route handlers)
      if (!route.path) {
        return {};
      }

      // Build relative URL for the current route
      const pathname = generatePath(route.path, params);
      const descriptor: Path = {
        hash: '',
        pathname,
        search: encodeQuery(query) ?? '',
      };

      return descriptor;
    },
    [routeId],
  );
